module.exports = __webpack_public_path__ + "static/media/panel.nav.f8572846.png";